import { render, staticRenderFns } from "./UploadAddressAndIdentityVerification.vue?vue&type=template&id=6ac5d409&"
import script from "./UploadAddressAndIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./UploadAddressAndIdentityVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports